import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { BookingInfoWorkspace } from '@/components/operator/booking-info-workspace'
import { OperatorWorkspaceRouteGate } from '@/components/operator/operator-workspace-route-gate'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/booking-info')({
  component: BookingInfoPage,
  staticData: {
    breadcrumbs: [{ label: 'Booking Info', href: '/booking-info' }],
  } satisfies RouteStaticData,
})

function BookingInfoPage() {
  const { configuration, isLoading, error, refreshAll } = useOperatorConfiguration()

  return (
    <WorkspaceRouteShell>
      <OperatorWorkspaceRouteGate
        configuration={configuration}
        isLoading={isLoading}
        error={error}
        onRetry={refreshAll}
        loadingCopy="Loading booking info..."
        resourceLabel="booking info"
        noOperatorTitle="Create your profile first."
        noOperatorDescription="Add your business identity before editing customer-facing booking information."
      >
        <BookingInfoWorkspace configuration={configuration} onSaved={refreshAll} />
      </OperatorWorkspaceRouteGate>
    </WorkspaceRouteShell>
  )
}
